module.exports = __webpack_public_path__ + "img/shanchu2.c834013f.svg";